import cx from 'clsx';

import { RedCoupon16x16Icon } from '~/assets/icons';

type Props = {
  className?: string;
  wFull?: boolean;
  is3x2?: boolean;
  totalDiscountAmount: number;
};

export const BigSaleTotalDiscountAmount = ({
  className,
  wFull = true,
  is3x2 = false,
  totalDiscountAmount,
}: Props) => {
  return (
    <div
      className={cx(
        'flex justify-center flex-wrap gap-[2px] typo-footnote300-semibold text-bigSale-text bg-bigSale-background rounded-[6px] text-center py-[2px] mt-[2px] break-keep',
        wFull ? 'w-full' : 'w-[140px]',
        is3x2 && '!block px-12',
        className,
      )}
    >
      <div className="flex items-center gap-4">
        <RedCoupon16x16Icon />
        최대
      </div>
      <div className="text-left">
        {totalDiscountAmount.toLocaleString()}원 할인
      </div>
    </div>
  );
};
